import { createContext } from 'react';

import { type ConfluenceExperimentsContextType } from './types';

export const ConfluenceExperimentsContext = createContext<ConfluenceExperimentsContextType>({
	usePageRecommendationData: () => ({
		data: undefined,
		loading: false,
		isError: false,
	}),
	useInlineReactionsData: (_numberOfReactedUsers: number, _skip: boolean) => ({
		data: {
			authorName: undefined,
			authorAvatar: undefined,
			reactionsCount: undefined,
			reactionsSummary: undefined,
			reactedUsers: undefined,
			userId: undefined,
			activationId: undefined,
		},
		loading: false,
		error: undefined,
	}),
	getPageDataFromUrl: () => ({
		contentId: undefined,
		contentType: undefined,
		spaceKey: undefined,
	}),
	emojiProvider: undefined,
});
